import I18n from 'I18n';
import { now, SimpleDate } from 'foundations-components/transitional/utils/SimpleDate';
import * as dateRangePresets from 'foundations-components/transitional/components/Dates';
export const ALL = {
  getText: () => I18n.text('dateFilters.allTime'),
  getValue: tz => ({
    startDate: new SimpleDate({
      year: 2000,
      month: 0,
      date: 1
    }),
    endDate: now(tz || 'userTz')
  }),
  presetId: 'ALL'
};
export const RANGE_TYPES = Object.assign({}, dateRangePresets, {
  ALL
});
export const PRESETS = Object.values(RANGE_TYPES);